export const status_penagihan = [
    {key: 'new', value: 'New'},
    {key: 'process', value: 'Process'},
    {key: 'finish', value: 'Finish'},
    {key: 'cancel', value: 'Cancel'},
]


// WEBPACK FOOTER //
// ./src/constants/penagihan.js